// Código de promotor del enlace `/activity/<id>?ref=CODIGO`.
//
// Solo se guarda en sessionStorage (muere con la pestaña; nunca en
// localStorage ni en la cuenta del cliente) y va ligado a la actividad del
// enlace: el promotor comparte una actividad concreta, así que un código
// guardado no se aplica a otra actividad que la persona abra después por su
// cuenta.
const KEY = 'promoter-ref';

// Los códigos del backend son de 8 caracteres alfanuméricos (p. ej. K7M2QX9P).
// Se acepta algo más amplio, pero nada que parezca otra cosa.
const CODE_FORMAT = /^[A-Za-z0-9_-]{4,32}$/;

export const cleanRefCode = (value) => {
  const code = String(value || '').trim();
  return CODE_FORMAT.test(code) ? code : '';
};

export const saveRef = (activityId, code) => {
  const clean = cleanRefCode(code);
  if (!clean) return false;
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ code: clean, activityId: String(activityId) }));
    return true;
  } catch (e) {
    return false;
  }
};

// Código guardado para esa actividad, o '' si no hay (o es de otra actividad).
export const readRef = (activityId) => {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return '';
    const data = JSON.parse(raw);
    if (!data || String(data.activityId) !== String(activityId)) return '';
    return cleanRefCode(data.code);
  } catch (e) {
    return '';
  }
};

export const clearRef = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {
    // nada que limpiar
  }
};
